<template>
  <pt-gene-lab-order class="pt-gene-lab-order__page" :isPrimaryUser="isPrimaryUser"></pt-gene-lab-order>
</template>

<script>
import { getIsPrimaryUser } from 'utils/action'
import PtGeneLabOrder from 'cps/lab-order/pt-gene-lab-order/withData'
export default {
  name: 'pt-gene-lab-order__view',
  components: {
    'pt-gene-lab-order': PtGeneLabOrder
  },
  data () {
    return {
      isPrimaryUser: true
    }
  },
  beforeRouteEnter (to, from, next) {
    getIsPrimaryUser().then(res => {
      next(vm => {
        vm.isPrimaryUser = res.data
      })
    })
  }
}
</script>
